export const coreFeatureKey = 'core';
